import { Link } from "@remix-run/react";
import { IcoAppStore, IcoGoogleStore } from "~/icons";

import freshReadsImg from "/img/fresh-reads.png";

const FreshReads = () => {
  return (
    <section className="py-16 max-md:pt-12 max-md:pb-5" id="fresh">
      <div className="container">
        <div className="max-md:grid-cols-1 grid grid-cols-2 h-[inherit] items-center">
          <div className="max-md:order-2 max-md:mt-8">
            <img
              className="mx-auto max-w-[521px] max-md:max-w-full"
              src={freshReadsImg}
              alt="Application Preview"
            />
          </div>
          <div className="max-md:order-1">
            <div className="max-w-[426px] mx-auto">
              <h2 className="max-lg:text-4xl max-lg:leading-[49px] text-center text-white text-[48px] font-extrabold leading-[66px]">
                Fresh Reads <br /> Each Week
              </h2>
              <p className="max-lg:text-xl max-lg:leading-7 text-center text-white text-2xl font-light tracking-tight mt-4">
                With 10+ fresh titles added weekly, you’ll never run out of
                stories to explore
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

FreshReads.disolayName = "FreshReads";
export default FreshReads;
